import { createSelector } from '@reduxjs/toolkit';

export const selectDialog = createSelector((store: any) => store, store => store.dialog);
export const selectHelp = createSelector(selectDialog, dialog => dialog.help);
